import { useState, useMemo, useEffect, useCallback, useRef } from "react";
import "./projectInfo.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { GoogleMap, MarkerF } from "@react-google-maps/api";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ProcessBar from "../MainComponent/processBar";
import { updateRoofInfo } from "../../../Features/roofInfo";
import { handleNextClick, backButton } from "./createProjectFunction";
import { saveAsDraft } from "../RoofSelection/roofFunction";
import { Link, useNavigate } from "react-router-dom";
import GridView from "./gridView";
import { updateGridInfo } from "../../../Features/gridViewInfo";
import { updateQuantityInfo } from "../../../Features/quantityInfo";
import { ProjectApi } from "../../../apis";
import { TextField, List, ListItem, ListItemButton } from "@mui/material";
import CustomInput from "../../../component/customInput";

const containerStyle = {
  width: "100%",
  height: "100%",
};

export default function ProjectInfo({ setLoader }) {
  const ProjectRouter = ProjectApi();
  // const CustomerRouter = CustomerApi();
  const roofInfo = useSelector((state) => state.roof);
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const conUser = useSelector((state) => state?.conUser);
  const reportInfo = useSelector((state) => state?.reportInfo);
  const user = conUser?.user;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showMarker, setShowMarker] = useState(true);
  const projectId = sessionStorage.getItem("projectId");
  const [selected, setSelected] = useState(null);
  const [siteAddress, setSiteAddress] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [ setEmptyValues] = useState(false);
  const screenRef = useRef(null);
  const [searchType, setSearchType] = useState(true);
  const [draftLoader, setDraftLoader] = useState(false);
  // const [data, setData] = useState([]);

  const generateGrid = (value, newZoom) => {
    let system = 0;
    for (let i = 0; i < value; i = i + newZoom) {
      system++;
    }
    return system;
  };

  // useEffect(() => {
  //   const fetchCustumer = async () => {
  //     const data = await CustomerRouter.getAll();

  //     setData(data.data);
  //   };
  //   fetchCustumer();
  // }, []);

  const handleInputChange = useCallback(
    (e) => {
      dispatch(updateRoofInfo({ [e.target.name]: e.target.value }));
    },
    [dispatch]
  );

  const mapFunction = (value) => {
    let newZoom = roofInfo?.value?.mapOption?.zoom
      ? roofInfo.value.mapOption.zoom
      : 15;
    let width = roofInfo.value.boxDimension.width;
    let height = roofInfo.value.boxDimension.height;
    if (!(value === "gridView")) {
      newZoom = 20;
    } else if (value === "gridView") {
      let row = generateGrid(height, gridInfo.zoom);
      let column = generateGrid(width, gridInfo.zoom);
      let zoom = gridInfo.zoom;
      dispatch(
        updateGridInfo({
          row,
          column,
          zoom,
        })
      );
      sessionStorage.removeItem("ImageSrc");
    }
    const mapOption = {
      mapTypeId: value,
      zoom: newZoom,
    };
    dispatch(updateRoofInfo({ mapOption: mapOption }));
    dispatch(updateRoofInfo({ polygonCoordinates: [] }));
    dispatch(updateRoofInfo({ abstacles: [] }));
    dispatch(updateQuantityInfo({ roofData: [] }));
  };

  const zoomFunction = (value) => {
    let newZoom = roofInfo.value.mapOption.zoom + value;
    let width = roofInfo.value.boxDimension.width;
    let height = roofInfo.value.boxDimension.height;
    let pixelValue = roofInfo?.value?.pixelValue
      ? roofInfo.value.pixelValue
      : 15;
    if (roofInfo.value.mapOption.mapTypeId === "gridView") {
      let row = generateGrid(height, gridInfo.zoom);
      let column = generateGrid(width, gridInfo.zoom);

      if (value === 1 && pixelValue > 1) {
        pixelValue--;
      } else if (value !== 1 && pixelValue < 30) {
        pixelValue++;
      }
      dispatch(
        updateGridInfo({
          row,
          column,
        })
      );
      dispatch(updateRoofInfo({ pixelValue: pixelValue }));
    }
    const mapOption = {
      mapTypeId: roofInfo.value.mapOption.mapTypeId,
      zoom: newZoom,
    };
    dispatch(updateRoofInfo({ mapOption: mapOption }));
    dispatch(updateRoofInfo({ polygonCoordinates: [] }));
    dispatch(updateRoofInfo({ abstacles: [] }));
    dispatch(updateQuantityInfo({ roofData: [] }));
  };

  const handleGridInfo = () => {
    let width = roofInfo.value.boxDimension.width;
    let height = roofInfo.value.boxDimension.height;
    let row = generateGrid(height, gridInfo.zoom);
    let column = generateGrid(width, gridInfo.zoom);
    dispatch(
      updateGridInfo({
        row,
        column,
      })
    );
  };

  useEffect(() => {
    const siteAddress = roofInfo.value.siteAddress;
    const handleSelect = async () => {
      setSiteAddress(siteAddress.value);
      setSelected(siteAddress.coordinates);
      let add;
      await getGeocode({
        lat: siteAddress.coordinates.lat,
        lng: siteAddress.coordinates.lng,
      }).then((results) => {
        add = results[0].formattedAddress;
        console.log(add);
      });
    };

    if (
      roofInfo?.value?.siteAddress?.coordinates?.lat !== "" &&
      roofInfo.value.mapOption.mapTypeId !== "gridView"
    ) {
      handleSelect();
    }
    handleGridInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roofInfo]);

  useEffect(() => {
    if (screenRef.current) {
      const boxDimension = {
        width: screenRef.current.offsetWidth - 5.2,
        height: screenRef.current.offsetHeight - 5.2,
      };
      dispatch(updateRoofInfo({ boxDimension: boxDimension }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchAddress = async () => {
      if (selected && selected.lat && selected.lng) {
        try {
          const results = await getGeocode({
            location: { lat: selected.lat, lng: selected.lng },
          });
          const formattedAddress = results[0].formatted_address;
          setSiteAddress(formattedAddress);
          dispatch(
            updateRoofInfo({
              siteAddress: {
                ...roofInfo.value.siteAddress,
                value: formattedAddress,
              },
            })
          );
          let newZoom = roofInfo?.value?.mapOption?.zoom
            ? roofInfo.value.mapOption.zoom
            : 20;
          const mapOption = {
            mapTypeId: roofInfo.value.mapOption.mapTypeId,
            zoom: newZoom,
          };
          dispatch(updateRoofInfo({ mapOption: mapOption }));
          setShowMarker(true);
        } catch (error) {
          console.log("Reverse geocoding error:", error);
        }
      }
    };
    fetchAddress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  const handleCoordinates = (e) => {
    const coord = e.target.value;
    const pattern = /([-+]?\d{1,3}(?:\.\d+)?),\s*([-+]?\d{1,3}(?:\.\d+)?)/;
    const matches = coord.match(pattern);
    if (matches) {
      const [lat, lng] = matches.slice(1).map(parseFloat);
      const updatedCoordinates = {
        lat: lat,
        lng: lng,
        coords: coord,
      };
      setSelected(updatedCoordinates);
      dispatch(
        updateRoofInfo({
          siteAddress: {
            ...roofInfo.value.siteAddress,
            coordinates: updatedCoordinates,
          },
        })
      );
      const mapOption = {
        mapTypeId: roofInfo.value.mapOption.mapTypeId,
        zoom: 20,
      };
      dispatch(updateRoofInfo({ mapOption: mapOption }));
      dispatch(updateRoofInfo({ polygonCoordinates: [] }));
      dispatch(updateRoofInfo({ abstacles: [] }));
      dispatch(updateQuantityInfo({ roofData: [] }));
    }
  };

  const handleUpdateAddress = (e) => {
    dispatch(
      updateRoofInfo({
        siteAddress: {
          ...roofInfo.value.siteAddress,
          value: e.target.value,
        },
      })
    );
  };

  // const handleUpdateCustomerDetail = (item) => {
  //   dispatch(
  //     updateRoofInfo({
  //       customerName: item.customerName,
  //       customerEmail: item.customerEmail,
  //       customerPhoneNo: item.customerPhoneNo,
  //     })
  //   );
  // };

  return (
    <>
      <div className="detailContainer">
        <div className="detailHead">
          <div className="detailHeader">
            <Link to="/Dashboard">
              <h6 style={{ color: "#FF7C1B" }}>My Project</h6>
            </Link>
            <h6>/</h6>
            {!projectId ? <h6>Create Project</h6> : <h6>Edit Project</h6>}
          </div>
          <ProcessBar
            setLoader={setLoader}
            screenRef={screenRef}
            setEmptyValues={setEmptyValues}
            setShowMarker={setShowMarker}
          ></ProcessBar>
        </div>
        <div className="projectInfoContainer">
          <div className="mainInfoBox">
            <div className="infoContainer">
              <div className="siteDetail">
                <h1>Site Details</h1>
                <CustomInput
                  id="siteName"
                  name="siteName"
                  title="Site Name"
                  value={roofInfo.value.siteName}
                  onChange={(e) => handleInputChange(e)}
                  required={true}
                  placeholder="site name"
                  width="240px"
                />

                {roofInfo.value.mapOption.mapTypeId === "gridView" ? (
                  <CustomInput
                    id="searchAddress"
                    name="searchAddress"
                    title="Address"
                    value={roofInfo.value.siteAddress.value}
                    onChange={(e) => handleUpdateAddress(e)}
                    required={false}
                    isRequired={false}
                    placeholder="Address"
                    width="240px"
                  />
                ) : (
                  <>
                    <div className="searchAddress">
                      <input
                        type="radio"
                        id="address"
                        name="searchAddress"
                        value="address"
                        onClick={() => setSearchType(true)}
                        defaultChecked={true}
                      />

                      <label htmlFor="address">Address</label>
                      <input
                        type="radio"
                        id="coordinates"
                        name="searchAddress"
                        value="coordinates"
                        onClick={() => setSearchType(false)}
                      />
                      <label htmlFor="coordinates">Coordinates</label>
                    </div>
                    <div className="inputField  ">
                      {searchType ? (
                        <PlacesAutocomplete
                          setSelected={setSelected}
                          siteAddress={siteAddress}
                          setSiteAddress={setSiteAddress}
                          roofInfo={roofInfo}
                          setShowMarker={setShowMarker}
                        />
                      ) : (
                        <TextField
                          label="Coordinates"
                          margin="dense"
                          variant="outlined"
                          sx={{ width: "240px" }}
                          value={roofInfo.value.siteAddress.coordinates.coords}
                          onChange={(e) => handleCoordinates(e)}
                        />
                      )}
                    </div>
                  </>
                )}

                <CustomInput
                  id="dateOfInstallation"
                  name="dateOfInstallation"
                  title="Planned Date of Installation"
                  type="date"
                  value={roofInfo.value.dateOfInstallation}
                  onChange={(e) => handleInputChange(e)}
                  required={true}
                  placeholder="date of installation"
                  width="240px"
                />
              </div>
              <div className="customerDetail">
                <h1>Customer Details</h1>
                {/* <Autocomplete
                  disablePortal
                  options={data}
                  getOptionLabel={(option) => option.customerName}
                  onChange={(event, newValue) =>
                    handleUpdateCustomerDetail(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Customer Name"
                      variant="outlined"
                    />
                  )}
                  style={{ width: 250, marginTop: 10 }}
                /> */}

                <CustomInput
                  id="customerName"
                  name="customerName"
                  title="Customer Name"
                  value={roofInfo.value.customerName}
                  onChange={(e) => handleInputChange(e)}
                  required={false}
                  isRequired={false}
                  placeholder="customer name"
                  width="240px"
                />
                <CustomInput
                  id="customerPhoneNo"
                  name="customerPhoneNo"
                  title="Phone No"
                  type="text"
                  value={roofInfo.value.customerPhoneNo}
                  onChange={(e) => handleInputChange(e)}
                  required={false}
                  isRequired={false}
                  placeholder="Phone No"
                  width="240px"
                />
                <CustomInput
                  id="customerEmail"
                  name="customerEmail"
                  title="Email Address"
                  value={roofInfo.value.customerEmail}
                  onChange={(e) => handleInputChange(e)}
                  required={false}
                  isRequired={false}
                  placeholder="Email Address"
                  width="240px"
                />
              </div>
            </div>
            <div className="mapContainer">
              {!(roofInfo.value.mapOption.mapTypeId === "gridView") ? (
                <h1>Location on Map</h1>
              ) : (
                <h1>Grid View</h1>
              )}
              <div className="mapOption">
                <h1
                  onClick={() => mapFunction("roadmap")}
                  style={{
                    color:
                      roofInfo.value.mapOption.mapTypeId === "roadmap"
                        ? "black"
                        : "#00000082",
                  }}
                >
                  Map
                </h1>
                <h1
                  onClick={() => mapFunction("satellite")}
                  style={{
                    color:
                      roofInfo.value.mapOption.mapTypeId === "satellite"
                        ? "black"
                        : "#00000082",
                  }}
                >
                  Satellite
                </h1>
                <h1
                  onClick={() => mapFunction("gridView")}
                  style={{
                    color:
                      roofInfo.value.mapOption.mapTypeId === "gridView"
                        ? "black"
                        : "#00000082",
                  }}
                >
                  Grid View
                </h1>
              </div>
              <div className="zoomOption">
                <i
                  className="bi bi-plus"
                  onClick={() => zoomFunction(1)}
                  style={{ color: "#00000082" }}
                ></i>
                <i
                  className="bi bi-dash"
                  onClick={() => zoomFunction(-1)}
                  style={{ color: "#00000082" }}
                ></i>
              </div>
              <div
                className="MapBox"
                id="firstMap"
                ref={screenRef}
                style={
                  roofInfo.value.mapOption.mapTypeId === "gridView"
                    ? { border: "1px solid lightgray" }
                    : {}
                }
              >
                {roofInfo.value.mapOption.mapTypeId === "gridView" ? (
                  <GridView></GridView>
                ) : (
                  <Map
                    selected={selected}
                    showMarker={showMarker}
                    setShowMarker={setShowMarker}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="containerButton">
            <div className="rightButton">
              <button onClick={() => backButton(navigate)}>
                <i className="bi bi-chevron-double-left"></i> Back
              </button>
            </div>
            <div className="rightButton">
              <button onClick={handleShow}>Save as Draft</button>
              <button
                className="nextButton"
                onClick={() =>
                  handleNextClick({
                    roofInfo,
                    screenRef,
                    setLoader,
                    setEmptyValues,
                    setShowMarker,
                    navigate,
                    dispatch,
                  })
                }
              >
                Next <i className="bi bi-chevron-double-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Discard Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to stop editing? You can save this project as
          draft and can continue later.
        </Modal.Body>
        <Modal.Footer>
          {draftLoader && (
            <div className="draftLoader">
              <div className="ring"></div>
              <img src="./images/Logos/flash.svg" alt="logo"></img>
            </div>
          )}
          <Button
            variant="secondary"
            onClick={() =>
              saveAsDraft({
                ProjectRouter,
                setDraftLoader,
                navigate,
                roofInfo,
                quantityInfo,
                user,
                reportInfo,
              })
            }
          >
            Save as Draft
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Discard
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function Map({ selected, showMarker, setShowMarker }) {
  const dispatch = useDispatch();
  const center = useMemo(() => ({ lat: 39.8283, lng: -98.5795 }), []);
  const roofInfo = useSelector((state) => state.roof, shallowEqual);
  const mapRef = useRef(null); // Reference to the Google Maps API instance

  const handleZoomChanged = () => {
    const newZoom = mapRef.current
      ? mapRef.current.getZoom()
      : roofInfo.value.mapOption.zoom;

    const mapOption = {
      mapTypeId: roofInfo.value.mapOption.mapTypeId,
      zoom: newZoom,
    };
    dispatch(updateRoofInfo({ mapOption: mapOption }));
  };

  const handleMapLoad = (map) => {
    mapRef.current = map;
    const newZoom = roofInfo?.value?.mapOption?.zoom
      ? roofInfo.value.mapOption.zoom
      : 15;
    const mapOption = {
      mapTypeId: roofInfo.value.mapOption.mapTypeId,
      zoom: newZoom,
    };
    setShowMarker(true);
    dispatch(updateRoofInfo({ mapOption: mapOption }));
  };

  const handleMapClick = async (event) => {
    const latLng = event.latLng;
    const lat = latLng.lat();
    const lng = latLng.lng();
    const coords = `${lat},${lng}`;
    dispatch(updateRoofInfo({ polygonCoordinates: [] }));
    dispatch(updateRoofInfo({ abstacles: [] }));
    dispatch(updateQuantityInfo({ roofData: [] }));
    try {
      const results = await getGeocode({ location: latLng });
      const formattedAddress = results[0].formatted_address;
      const updatedAddress = {
        value: formattedAddress,
        coordinates: { lat, lng, coords },
      };
      dispatch(updateRoofInfo({ siteAddress: updatedAddress }));
    } catch (error) {
      console.log("Reverse geocoding error:", error);
    }

    handleZoomChanged();
    setShowMarker(true);
  };

  return (
    <>
      <GoogleMap
        zoom={
          roofInfo?.value?.mapOption?.zoom ? roofInfo.value.mapOption.zoom : 15
        }
        mapTypeId={
          roofInfo.value.mapOption
            ? roofInfo.value.mapOption.mapTypeId
            : "roadmap"
        }
        center={selected || center}
        mapContainerStyle={containerStyle}
        onLoad={handleMapLoad}
        onZoomChanged={handleZoomChanged}
        onClick={handleMapClick} // Add onClick event handler for map click
      >
        {selected && showMarker && <MarkerF position={selected} />}
      </GoogleMap>
    </>
  );
}

const PlacesAutocomplete = ({
  setSelected,
  siteAddress,
  setSiteAddress,
  roofInfo,
  setShowMarker,
}) => {
  const {
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete();

  const dispatch = useDispatch();

  const handleSelect = async (address) => {
    setValue(address, false);
    clearSuggestions();

    try {
      const results = await getGeocode({ address });
      const { lat, lng } = await getLatLng(results[0]);
      const coords = `${lat}, ${lng}`;

      const updatedAddress = {
        value: address,
        coordinates: {
          lat,
          lng,
          coords,
        },
      };

      const mapOption = {
        mapTypeId: roofInfo.value.mapOption.mapTypeId,
        zoom: 20,
      };

      dispatch(updateRoofInfo({ mapOption }));
      dispatch(updateRoofInfo({ siteAddress: updatedAddress }));

      setSelected({ lat, lng });
      setShowMarker(true);
    } catch (error) {
      console.error("Error fetching geocode data:", error);
    }
  };

  return (
    <div>
      <TextField
        fullWidth
        value={value || siteAddress || ""}
        placeholder="Search an address"
        onChange={(e) => {
          setValue(e.target.value);
          setSiteAddress(e.target.value);
        }}
        onFocus={() => clearSuggestions()}
        InputProps={{
          sx: {
            color: "#6c757d",
          },
        }}
      />

      {status === "OK" && data.length > 0 && (
        <List
          sx={{
            maxHeight: "200px",
            overflow: "auto",
            border: "1px solid lightgrey",
            borderRadius: "4px",
            marginTop: "2px",
          }}
        >
          {data.map((suggestion, index) => (
            <ListItem key={index} disablePadding>
              <ListItemButton
                onClick={() => handleSelect(suggestion.description)}
                sx={{ fontSize: "0.9rem", color: "#333" }}
              >
                {suggestion.description}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </div>
  );
};
